import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ContextMenuPlugin } from '@/plugins/context-menu';
import { PluginType, type IExportPlugin } from '@/version-types';
import { GroupLayerHotkeyType } from '../../type';
import { alignInnerItem } from './align-inner-item';
import { groupPackItem } from './group-pack-item';
import { groupUnpackItem } from './group-unpack-item';

const GroupLayerContentMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);
        framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').addContextMenu([
            {
                key: GroupLayerHotkeyType.PACK,
                group: 2,
                sort: 1,
                render: groupPackItem,
            },
            {
                key: GroupLayerHotkeyType.UNPACK,
                group: 2,
                sort: 2,
                render: groupUnpackItem,
            },
            {
                key: 'alignInner',
                group: 4,
                sort: 1,
                render: alignInnerItem,
            },
        ]);
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'group-layer-content-menu',
    render() {
        return <GroupLayerContentMenuView />;
    },
};

export default exportPlugin;
